"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SINGULAR_CLAIM_TYPES = exports.VALIDATABLE_CLAIM_TYPES = exports.VERIFIABLE_CLAIM_TYPES = exports.ClaimTypes = exports.now = exports.TimestampType = exports.SignatureType = void 0;
var t = __importStar(require("io-ts"));
exports.SignatureType = t.string;
exports.TimestampType = t.number;
var now = function () { return Math.round(new Date().getTime() / 1000); };
exports.now = now;
var ClaimTypes;
(function (ClaimTypes) {
    ClaimTypes["ATTESTATION_SERVICE_URL"] = "ATTESTATION_SERVICE_URL";
    ClaimTypes["ACCOUNT"] = "ACCOUNT";
    ClaimTypes["DOMAIN"] = "DOMAIN";
    ClaimTypes["KEYBASE"] = "KEYBASE";
    ClaimTypes["NAME"] = "NAME";
    ClaimTypes["PROFILE_PICTURE"] = "PROFILE_PICTURE";
    ClaimTypes["STORAGE"] = "STORAGE";
    ClaimTypes["TWITTER"] = "TWITTER";
})(ClaimTypes = exports.ClaimTypes || (exports.ClaimTypes = {}));
exports.VERIFIABLE_CLAIM_TYPES = [ClaimTypes.KEYBASE, ClaimTypes.ACCOUNT, ClaimTypes.DOMAIN];
// Claims whose status can be validated
exports.VALIDATABLE_CLAIM_TYPES = [ClaimTypes.ATTESTATION_SERVICE_URL];
exports.SINGULAR_CLAIM_TYPES = [ClaimTypes.NAME, ClaimTypes.ATTESTATION_SERVICE_URL];
//# sourceMappingURL=types.js.map